/* eslint-disable no-undef */
// Note: We use raw-loader here since we don't want the styles to be parsed into an object, we just want the actual css text
// so we can place it in the shadow dom.
import styles from '!raw-loader!sass-loader!./SupercastLogin.scss';
import { domain } from 'utils/environment';

export default class SupercastLogin extends HTMLElement {
  connectedCallback() {
    this.subdomain = this.attributes.subdomain && this.attributes.subdomain.value;
    this.environment = (this.attributes.environment && this.attributes.environment.value) || "production";

    this.updateContent();
  }

  async updateContent() {
    const shadow = this.attachShadow({mode: 'open'});
    this.attachStyles(shadow);

    const cardContent = await this.fetchContent();

    shadow.appendChild(cardContent);

    this.attachEvents(shadow);
  }

  async fetchContent() {
    const template = document.createElement('template')
    template.innerHTML = `<div class='modal-container'>
      <div class='overlay'>
        <div class='modal'>
          <h2>Sign in with your Supercast account</h2>
          <form id='login-form' class='sc-form'>
            <div class='error' id='error'></div>
            <div class='field'>
              <input class='sc-input string'  type='text' name='email' placeholder='Email' />
            </div>
            <div class='field'>
              <input class='sc-input string' type='password' name='password' placeholder='Password' />
            </div>
            <div>
              <button type='button' class='button positive' id='login-button'>Sign In</button>
            </div>
            <div style='margin-top: 15px;'>
              <em>Trouble logging in? <a href='${`${domain(this.subdomain, this.environment)}/session/new`}' target="_blank">Click here</a> to receive a login e-mail or reset your password.</em>
            </div>
          </form>
        </div>
      </div>
    </div>`
    return template.content.cloneNode(true);
  }

  async attachStyles() {
    const styleEl = document.createElement('style');
    styleEl.textContent = styles;
    this.shadowRoot.appendChild(styleEl);
    return styleEl;
  }

  async login(e) {
    e.preventDefault();
    const form = this.shadowRoot.querySelector('#login-form');
    const { success, error } = await Supercast.login({ subdomain: this.subdomain, environment: this.environment, email: form.elements["email"].value, password: form.elements["password"].value });

    if (success) {
      this.close();
    } else {
      this.shadowRoot.querySelector('#error').textContent = error;
    }
  }

  close() {
    this.parentNode.removeChild(this);
  }

  attachEvents(shadow) {
    const overlay = shadow.querySelector('.overlay')
    shadow.querySelector('.overlay').addEventListener('click', (event) => {
      // Only consider direct events
      if (event.target == overlay) {
        this.close();
      }
    });

    shadow.querySelector('#login-button').addEventListener('click', this.login.bind(this));
  }
}